import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import {
  autoLogin,
  authSignIn,
  authSignOut,
} from '../services/auth';
import { authErrorState, authUserState, currentPageState, isLoggedInState } from '../storage/app';
import { useClearStorage } from './useClearStorage';
import { ApiError } from '@gorila-shared-ui/components/';
import { LOGIN_PAGE } from '../constants/app';
import { useRef } from 'react';

export function useAuth() {
  const setAuthUser = useSetRecoilState(authUserState);
  const setLoggedIn = useSetRecoilState(isLoggedInState);
  const [loginError, setLoginError] = useRecoilState(authErrorState);
  const page = useRecoilValue(currentPageState);
  const isInitAppPending = useRef(false);
  const clearStorage = useClearStorage();

  const login = async (username: string, password: string) => {
    const { error } = await authSignIn(username, password); 
    if (!error) {
      await initApp();
    } else {
      return { error };
    }
  };

  const initApp = async () => {
    if (isInitAppPending.current) return;
    isInitAppPending.current = true;
    if (page.id === LOGIN_PAGE.id && loginError) {
      isInitAppPending.current = false;
      return;
    } 
    const { user, error } = await autoLogin();
    if (user && !error) {
      setLoggedIn(true);
      setAuthUser(user);
    } else {
      logout();
      setLoginError(error as ApiError)
    }
    isInitAppPending.current = false;
  };

  const logout = async () => {
    await authSignOut();
    clearStorage();
    setLoggedIn(false);
  };

  return {
    login,
    logout,
    initApp,
  };
}
